import "./CustomerDetailsRegister.css";
import '../../App.css';
import patientregisterimg from "../../media/login_img.png";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../../Component/StateProviders";
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import toast from "react-hot-toast";

function CustomerDetailsRegister() {
    let navigate = useNavigate();
    const [{ IsLogin, IsRegister }, dispatch] = useStateValue();

    const [options, setoptions] = useState([true, false, false, false]);
    const [name, setname] = useState("");
    const [Phnumber, setPhnumber] = useState("");
    const [age, setAge] = useState("");
    const [Img, setImg] = useState("");
    const [gender, setgender] = useState("male");
    const [Weight, setWeight] = useState("");
    const [height, setheight] = useState("");
    const [goalWeight, setGoalWeight] = useState("");
    const [medicalConditions, setMedicalConditions] = useState("");
    const [healthBudget, setHealthBudget] = useState("");
    const [referralSource, setReferralSource] = useState("");
    const location = "UAE";

    const [City, setCity] = useState("");
    const [file, setFile] = useState();
    const [Pincode, setPincode] = useState("");
    const [showImg, setshowImg] = useState();
    const [Activegender, setActivegender] = useState([false, false]);


    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };


    return (
        <>
            <div className="mt-5 mb-5 container">
                <div className="client_register_second_third_merge_main_division">
                    <div className="client_register_second_main_division">
                        <div
                            className="client_register_registration_main_division"
                            onClick={() => {
                                if (options[0]) {
                                    setoptions([true, false, false, false]);
                                }
                            }}
                        >
                            <div className="client_register_registration_number_division">
                                <span
                                    className={
                                        options[0]
                                            ? "client_register_registration_number_title_active"
                                            : "client_register_registration_number_title"
                                    }
                                >
                                    1
                                </span>
                            </div>
                            <div className="client_register_registration_division mx-2">
                                <div className="client_register_registration_title mb-1">
                                    Registration
                                </div>
                                <div>
                                    Enter your Basic details for Registration
                                </div>
                            </div>
                        </div>

                        <div
                            className="client_register_registration_main_division"
                            onClick={() => {
                                if (options[1]) setoptions([true, true, false, false]);
                            }}
                        >
                            <div className="client_register_registration_number_division">
                                <div
                                    className={
                                        options[1]
                                            ? "client_register_registration_number_title_active"
                                            : "client_register_registration_number_title"
                                    }
                                >
                                    2
                                </div>
                            </div>
                            <div className="client_register_registration_division mx-2">
                                <div className="client_register_registration_title mb-1">
                                    Profile Picture
                                </div>
                                <div>
                                    Upload your Profile Picture
                                </div>
                            </div>
                        </div>

                        <div
                            className="client_register_registration_main_division"
                            onClick={() => {
                                if (options[2]) setoptions([true, true, true, false]);
                            }}
                        >
                            <div className="client_register_registration_number_division">
                                <div
                                    className={
                                        options[2]
                                            ? "client_register_registration_number_title_active"
                                            : "client_register_registration_number_title"
                                    }
                                >
                                    3
                                </div>
                            </div>
                            <div className="client_register_registration_division mx-2">
                                <div className="client_register_registration_title mb-1">
                                    Personal Details
                                </div>
                                <div>
                                    Enter your Personal Details
                                </div>
                            </div>
                        </div>

                        <div
                            className="client_register_registration_main_division"
                            onClick={() => {
                                if (options[3]) {
                                    setoptions([true, true, true, true]);
                                }
                            }}
                        >
                            <div className="client_register_registration_number_division">
                                <div
                                    className={
                                        options[3]
                                            ? "client_register_registration_number_title_active"
                                            : "client_register_registration_number_title"
                                    }
                                >
                                    4
                                </div>
                            </div>
                            <div className="client_register_registration_division mx-2">
                                <div className="client_register_registration_title mb-1">
                                    Other Detail
                                </div>
                                <div >
                                    Provide More information
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* registration step 1 start */}
                    {options[0] && !options[1] ? (
                        <div className="client_register_third_main_division">
                            {/* <div className="client_register_registration_details_main_division">
                                Whats your Number?
                                <span className="client_register_registration_star_icon">
                                    *
                                </span>
                            </div>
                            <div className="client_register_registration_details_sub_division">
                                We will only use it to advise you for any important changes.
                            </div> */}

                            <TextField id="outlined-basic" label=" Full Name*" variant="outlined" className="w-100 mt-2" value={name}
                                onChange={(e) => {
                                    setname(e.target.value);
                                }}
                            />





                            <TextField id="outlined-basic" label="Contact Number*" variant="outlined" className="w-100 mt-3" value={Phnumber}
                                onChange={(e) => {
                                    setPhnumber(e.target.value);
                                }}
                            />

                            <TextField id="outlined-basic" label="Age*" variant="outlined" className="w-100 mt-3" value={age}
                                onChange={(e) => {
                                    setAge(e.target.value);
                                }}
                            />




                            <button
                                className="client_register_continue_btn"
                                onClick={() => {
                                    if (Phnumber !== "" && name !== "" && age !== "") {
                                        setoptions([true, true, false, false]);
                                    } else {
                                        toast.error("Enter Name, Contact Number, and Age");
                                    }
                                }}
                            >
                                Continue <i class="fa-solid fa-chevron-right ms-3"></i>
                            </button>
                        </div>
                    ) : null}

                    {/* registration step 1 end */}

                    {/* upload img step 2 start */}
                    {options[1] && !options[2] ? (
                        <div className="client_register_third_main_division">
                            <div className="client_register_registration_details_main_division">
                                Upload Profile Picture
                            </div>
                            <div className="client_register_registration_details_sub_division">
                                Add a profile photo
                            </div>

                            <div className="client_register_upload_img_main_division">
                                {showImg ?
                                    <img src={showImg} />
                                    :
                                    <div className="client_register_upload_img_division">
                                        <i class="fa-solid fa-camera"></i>
                                    </div>}
                            </div>

                            <div className="client_register_upload_images_main_division">

                                <button
                                    type="button"
                                    className="clientregister_upload_photo_button btn"
                                >
                                    <i className="fa fa-upload profilesettings_upload_icon"></i>{" "}
                                    Upload Photo
                                    <input
                                        type="file"
                                        accept="image/gif, image/jpeg, image/png"
                                        onChange={(e) => {
                                            setImg(e.target.files[0]);

                                            setshowImg(URL.createObjectURL(e.target.files[0]));
                                        }}
                                    />
                                </button>
                            </div>

                            <button
                                className="client_register_continue_btn"
                                onClick={() => {
                                    setoptions([true, true, true, false]);
                                }}
                            >
                                Continue <i class="fa-solid fa-chevron-right ms-3"></i>
                            </button>
                        </div>
                    ) : null}

                    {/* upload img step 2 end */}

                    {/* personal details step 3 start */}

                    {options[2] && !options[3] ? (
                        <div className="client_register_third_main_division">
                            <div className="client_register_registration_details_main_division">
                                What are your personal details?
                                <span className="client_register_registration_star_icon">
                                    *
                                </span>
                            </div>
                            <div className="client_register_registration_details_sub_division">
                                Please provide your personal information
                            </div>

                            <div className="client_register_personal_gender_main_division">
                                <button className={
                                    Activegender[0]
                                        ? "client_register_personal_male_btn_active"
                                        : "client_register_personal_male_btn"
                                }
                                    onClick={() => {
                                        setgender("male");
                                        setActivegender([true, false]);
                                    }}
                                >
                                    <i class="fa-solid fa-mars-stroke"></i> Male
                                </button>
                                <button
                                    className={Activegender[1] ? "client_register_personal_female_btn_active" : "client_register_personal_female_btn"
                                    }
                                    onClick={() => {
                                        setgender("female");
                                        setActivegender([false, true]);
                                    }}
                                >
                                    <i class="fa-solid fa-mars-stroke-up"></i> Female
                                </button>
                            </div>


                            <TextField id="outlined-basic" label="Location" variant="outlined" className="w-100 mt-3" value={location} disabled />

                            <TextField id="outlined-basic" label="Height*" variant="outlined" className="w-100 mt-3" value={height}
                                onChange={(e) => {
                                    setheight(e.target.value);
                                }}
                            />

                            <TextField id="outlined-basic" label="Current Weight*" variant="outlined" className="w-100 mt-3" value={Weight}
                                onChange={(e) => {
                                    setWeight(e.target.value);
                                }}
                            />

                            <TextField id="outlined-basic" label="Goal Weight*" variant="outlined" className="w-100 mt-3" value={goalWeight}
                                onChange={(e) => {
                                    setGoalWeight(e.target.value);
                                }}
                            />

                            <TextField id="outlined-basic" label="Medical Conditions" variant="outlined" className="w-100 mt-3" value={medicalConditions}
                                multiline
                                minRows={2}
                                onChange={(e) => {
                                    setMedicalConditions(e.target.value);
                                }}
                            />

                            <button
                                className="client_register_continue_btn"
                                onClick={() => {
                                    if (height !== "" && Weight !== "" && goalWeight !== "") {
                                        setoptions([true, true, true, true]);
                                    } else {
                                        toast.error("Enter Height, Current Weight, and Goal Weight");
                                    }
                                }}
                            >
                                Continue <i class="fa-solid fa-chevron-right ms-3"></i>
                            </button>
                        </div>
                    ) : null}

                    {/* personal details step 3 end */}

                    {/* other details step 4 start */}

                    {options[3] ? (
                        <div className="client_register_third_main_division">
                            <div className="client_register_registration_details_main_division">
                                Other Details
                                <span className="client_register_registration_star_icon">
                                    *
                                </span>
                            </div>
                            <div className="client_register_registration_details_sub_division">
                                Please fill the details below
                            </div>


                            <TextField id="outlined-basic" label="City*" variant="outlined" className="w-100 mt-3" value={City}
                                onChange={(e) => {
                                    setCity(e.target.value);
                                }}
                            />

                            <TextField id="outlined-basic" label="How much budget have you set aside for your health?*" variant="outlined" className="w-100 mt-3" value={healthBudget}
                                onChange={(e) => {
                                    setHealthBudget(e.target.value);
                                }}
                            />

                            <TextField id="outlined-basic" label="How did you get to know about us?*" variant="outlined" className="w-100 mt-3" value={referralSource}
                                onChange={(e) => {
                                    setReferralSource(e.target.value);
                                }}
                            />


                            <button
                                className="client_register_continue_btn"
                                onClick={() => {
                                    console.log(IsRegister);
                                    if (options[3]) {
                                        if (City !== "" && healthBudget !== "" && referralSource !== "") {
                                            var Url =
                                                window.API_PREFIX + "patient/add_registration_data";

                                            var uploadData = new FormData();
                                            uploadData.append(
                                                "Token",
                                                localStorage.getItem("DToken")
                                            );
                                            uploadData.append("Name", name);
                                            uploadData.append("Pic", Img);
                                            uploadData.append("Gender", gender);
                                            uploadData.append("Weight", Weight);
                                            uploadData.append("Height", height);
                                            uploadData.append("Age", age);
                                            uploadData.append("GoalWeight", goalWeight);
                                            uploadData.append("MedicalConditions", medicalConditions);
                                            uploadData.append("HealthBudget", healthBudget);
                                            uploadData.append("ReferralSource", referralSource);
                                            uploadData.append("Location", location);
                                            uploadData.append("Birthdate", "");

                                            uploadData.append("Address", "");
                                            uploadData.append("City", City);
                                            uploadData.append("State", "");
                                            uploadData.append("Country", location);
                                            uploadData.append("Pincode", "");
                                            uploadData.append("OtherInformation", "");
                                            uploadData.append("Mobile", Phnumber);

                                            fetch(Url, {
                                                method: "POST",
                                                // headers: {
                                                //     'Content-type': 'application/json',
                                                // },
                                                body: uploadData,
                                            })
                                                .then((resp) => resp.json())
                                                .then((data) => {
                                                    console.log(data);
                                                    if (data["status"] === "1") {
                                                        toast.success("Your Details Successfully Registered");
                                                        dispatch({ type: "Register" });
                                                        dispatch({ type: "Login" });
                                                        navigate("/dashboard");
                                                    }
                                                });
                                        } else {
                                            toast.error("Enter City, Health Budget, and How you heard about us");
                                        }
                                    }
                                }}
                            >
                                Continue <i class="fa-solid fa-chevron-right ms-3"></i>
                            </button>
                        </div>
                    ) : null}

                    {/* other details step 4 end */}
                </div>
            </div>
        </>
    );
}

export default CustomerDetailsRegister;
